/**
 * How long the browser keeps a download's object URL alive after the click. Some browsers start the download a moment
 * after `click()` returns and need the URL until then: revoking it in the same tick can cancel the download or save an
 * empty file.
 */
export const REVOKE_AFTER_MS = 1000;

/**
 * Hands the browser a file it was given as a Blob, under its own name. Never opened in a tab, so nothing a file contains runs
 * in the tracker's origin. Shared by the Word download and the documents attached to a request (#656).
 */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS);
}
